import artifact from '$houdini/artifacts/UpdateDashboardReport'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateDashboardReportStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
